module.exports = __webpack_public_path__ + "static/media/song-b.104df9cf.jpg";